import { View } from 'react-native'
import Typography from '@ca/ui/typography'

export function Row({ label, value }: { label: string; value: string }) {
  return (
    <View className="flex-row justify-between border-b border-black/10 py-1">
      <Typography variant="XS" className="w-32 text-black/50">
        {label}
      </Typography>
      <Typography variant="XS" className="font-mono flex-1 text-right text-black">
        {value}
      </Typography>
    </View>
  )
}
